module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=JP - Japan.24d31b31.svg";